export default "__VITE_ASSET__DxXroNbW__"